import React from 'react';
import {Menu} from 'components/customer/RoomPlanner/components/Menu';
import {useRoomPlannerLeftMenu} from 'components/customer/RoomPlanner/helper/useRoomPlannerLeftMenu';
import useUI from 'shared/useUI';
import {SidebarStatus, SidebarBehaviour} from 'store/customer/UISlice';
import {BaseConfig} from 'config';
import {usePlannerLayout} from 'components/customer/RoomPlanner/helper/usePlannerLayout';

interface ContextMenuProps {
    mobileView?: boolean;
}

export const ContextMenu = ({mobileView = false}: ContextMenuProps) => {
    const {isRoomPlannerPage} = useRoomPlannerLeftMenu();
    const {leftSidebar, leftSidebarBehaviour} = useUI();
    const {showFooterMenu} = usePlannerLayout();

    return (
        <>
            {!!isRoomPlannerPage ? (
                <Menu
                    isCollapsed={
                        leftSidebar != SidebarStatus.OPEN &&
                        leftSidebarBehaviour === SidebarBehaviour.TOGGLE
                    }
                    menu={BaseConfig.USER_CUSTOMER.roomPlannerMenu}
                    mobileView={mobileView}
                />
            ) : null}
            {!!isRoomPlannerPage && showFooterMenu ? (
                <Menu
                    isCollapsed={
                        leftSidebar != SidebarStatus.OPEN &&
                        leftSidebarBehaviour === SidebarBehaviour.TOGGLE
                    }
                    isFooter={true}
                    menu={BaseConfig.USER_CUSTOMER.roomPlannerBottomMenu}
                />
            ) : null}
        </>
    );
};
